<template>
  <article :class="{ cards: !row, 'cards-row': row }">
    <slot />
  </article>
</template>

<script lang="ts" setup>
interface Props{
  row?: true;
}
defineProps<Props>();
</script>

<style lang="scss" scoped>
.cards {
  @apply flex flex-col items-center gap-y-10;
  @apply mx-auto;
  @apply w-card-content;
}
.cards-row {
  @apply flex flex-row items-center gap-x-10;
  @apply my-auto;
}
</style>
